import { Layout } from '@/core/layout/layout';
import { type RouteRecordRaw } from 'vue-router';

export default {
    path: '/general-flow/:id',
    component: () => import('@/components/GeneralFlow/GeneralFlowView.vue'),
    name: 'general-client-details',
    meta: {
        private: true,
        layout: Layout.HeaderOnly,
        dossier: 'client',
    },
} as RouteRecordRaw;
